const intergrationBlock = document.querySelector('.schools-integration__grid')

function adjustLastRowWidths(containerSelector, cardSelector) {
    const container = document.querySelector(containerSelector);
    const cards = Array.from(container.querySelectorAll(cardSelector));
  
    if (!container || cards.length === 0) return;
  
    // Сброс ширины всем
    cards.forEach(card => {
      card.style.width = '';
    });
  
    // Получаем top каждой карточки
    const rows = new Map();
  
    cards.forEach(card => {
      const top = card.getBoundingClientRect().top;
      if (!rows.has(top)) {
        rows.set(top, []);
      }
      rows.get(top).push(card);
    });
  
    // Получаем последнюю строку
    const lastRow = Array.from(rows.values()).pop();
  
    if (!lastRow) return;
  
    if (lastRow.length === 1) {
      lastRow[0].style.width = '100%';
    } else if (lastRow.length === 2) {
      lastRow.forEach(card => {
        card.style.width = '50%';
      });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if(intergrationBlock)  adjustLastRowWidths('.schools-integration__grid', '.schools-integration__item');
});
  
window.addEventListener('resize', () => {
    if(intergrationBlock) adjustLastRowWidths('.schools-integration__grid', '.schools-integration__item');
});